export default "__VITE_ASSET__D$ScUulU__"